module.exports = __webpack_public_path__ + "img/1c59a0e.jpg";